import { render, staticRenderFns } from "./EditarHabilitacaoCasamento.vue?vue&type=template&id=29fe446a&"
import script from "./EditarHabilitacaoCasamento.vue?vue&type=script&lang=js&"
export * from "./EditarHabilitacaoCasamento.vue?vue&type=script&lang=js&"
import style0 from "./EditarHabilitacaoCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports